import { SidebarLink } from '@/analytics/enums/sidebar.enums'
import type { TrackEventFn } from '@/analytics/hooks/useAnalytics'
import { AnalyticsEvent } from '@/analytics/schema/events.schema'

const sidebarLinkByItemId: Record<string, SidebarLink> = {
  matters: SidebarLink.Matters,
  home: SidebarLink.BackToAllMatters,
  'matter-overview': SidebarLink.MatterOverview,
  'user-files': SidebarLink.MatterFiles,
  drafts: SidebarLink.Drafts,
  tables: SidebarLink.Tables,
  timeline: SidebarLink.Timeline,
  chronology: SidebarLink.MedicalChronology,
  'billing-summary': SidebarLink.MedicalBills,
}

export function trackSidebarLinkClicked(track: TrackEventFn, itemId: string, sideNavCollapsed: boolean) {
  const sidebarLink = sidebarLinkByItemId[itemId]
  if (!sidebarLink) return
  track(AnalyticsEvent.SidebarLinkClicked, { sidebarLink, sideNavCollapsed })
}
